import Crud from './crud'
import Vue from 'vue';
import config from '@/configs';
import { request_header } from '@/commons/hpod';
import { sendSuccessNotice, sendErrorNotice, refreshResource } from '@/commons/utils';

var crud = new Crud('auto-topup-logs', 'nhật ký nạp tiền tự động');

const state = {
    ...crud.state,
    selected: {
        ID: 0,
        Client: '',
        PackageName: '',
        AppName: '',
        Address: '',
        Body: '',
        DateMs: '',
        Status: 0,
        Message: '',
        CustomerID: null,
        Amount: 0,
        RechargeID: null,
        ModifiedBy: '',
        ModifiedDate: '',
        CreatedDate: ''
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    cancelLog({ commit, rootState }, { id, onSuccess }) {
        commit("setLoading", { loading: true });
        const req = {
            headers: request_header(rootState.authentication.token)
        };
        Vue.http.post(`${config.API}/admin/api/auto-topup-logs/${id}/cancel/`, {}, req).then(res => {
            commit("setLoading", { loading: false });
            sendSuccessNotice('Hủy tin nhắn nạp tiền thành công.');
            if (onSuccess) onSuccess(res.body);
            refreshResource();
        }).catch(err => {
            commit("setLoading", { loading: false });
            let msg = err.body && (err.body.reason || err.body.message) ? (err.body.reason || err.body.message) : 'Không thể hủy tin nhắn nạp tiền.';
            sendErrorNotice(msg);
        });
    },
    manualRecharge({ commit, rootState }, { data, onSuccess }) {
        commit("setLoading", { loading: true });
        const req = {
            headers: request_header(rootState.authentication.token)
        };
        Vue.http.post(`${config.API}/admin/api/auto-topup-logs/${data.id}/recharge/`, data, req).then(res => {
            commit("setLoading", { loading: false });
            sendSuccessNotice('Nạp tiền cho khách hàng thành công.');
            if (onSuccess) onSuccess(res.body);
            refreshResource();
        }).catch(err => {
            commit("setLoading", { loading: false });
            let msg = err.body && (err.body.reason || err.body.message) ? (err.body.reason || err.body.message) : 'Không thể thực hiện nạp tiền.';
            sendErrorNotice(msg);
        });
    }
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
